module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "panel notification is-paddingless",
    attrs: {
      "id": "task-text-formatting-instructions"
    }
  }, [_c('p', {
    staticClass: "panel-block"
  }), _c('h4', {
    staticClass: "heading is-4 has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['rules']))]), _c('p'), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("[" + _vm._s(_vm.tokens['empty_line']) + "]")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['separator']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("|")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['styles'])), _c('span', {
    staticClass: "explanation is-inline-block"
  }, [_vm._v(_vm._s(_vm.tokens['word']) + ":"), _vm._m(0)]), _c('span', {
    staticClass: "explanation is-inline-block"
  }, [_vm._v(_vm._s(_vm.tokens['line']) + ":"), _vm._m(1)])])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_c('a', {
    attrs: {
      "href": "https://www.w3schools.com/cssref/css_colors.asp",
      "target": "_blank"
    }
  }, [_vm._v("red")]), _c('span'), _c('a', {
    attrs: {
      "href": "https://www.w3schools.com/colors/colors_rgb.asp",
      "target": "_blank"
    }
  }, [_vm._v("#22aaff")]), _c('span'), _c('abbr', {
    attrs: {
      "title": _vm.tokens['lighter']
    }
  }, [_vm._v("light")]), _c('span'), _c('abbr', {
    attrs: {
      "title": _vm.tokens['darker']
    }
  }, [_vm._v("dark")])]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['color']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("22pt")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['size']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("italic regular")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['style']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('code', [_vm._v("normal bold")]), _c('span', {
    staticClass: "explanation"
  }, [_vm._v(_vm._s(_vm.tokens['weight']))])]), _c('p', {
    staticClass: "panel-block"
  }, [_c('span', {
    staticClass: "has-text-centered"
  }, [_c('h4', {
    staticClass: "heading is-4 is-inline has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['example']))]), _c('i', {
    staticClass: "is-block"
  }, [_vm._v("A big grey line with blue|#22aaff & italic|italic words |grey,18pt")]), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example"
  }, [_c('i', [_vm._v("Iso koulupiha|bold")]), _c('span', [_vm._v("= Iso")]), _c('b', [_vm._v("koulupiha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "example"
  }, [_c('i', [_vm._v("Iso koulupiha |bold")]), _c('span', [_vm._v("=")]), _c('b', [_vm._v("Iso koulupiha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-block",
    staticStyle: {
      "color": "grey",
      "font-size": "18pt"
    }
  }, [_c('span', [_vm._v("A big grey line with")]), _c('span', {
    staticStyle: {
      "color": "#22aaff"
    }
  }, [_vm._v("blue")]), _c('span', [_vm._v("&")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("italic")]), _c('span', [_vm._v("words")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb9d777"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TaskTextFormattingInstructions.vue
// module id = 406
// module chunks = 0